import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import VideoDetailView from '@/views/VideoDetailView.vue'
import SeriesDetailView from '@/views/SeriesDetailView.vue'
import VideoPlayerView from '@/views/VideoPlayerView.vue'
import { authGuard } from '@auth0/auth0-vue'


const protectedRoutes = [
]

const buildVideoSlugRedirect = (targetName) => (to) => {
  const rawVideoSlug = Array.isArray(to.query.videoSlug)
    ? to.query.videoSlug[0]
    : to.query.videoSlug

  if (!rawVideoSlug || typeof rawVideoSlug !== 'string') {
    return { name: '404' }
  }

  const normalizedSlug = rawVideoSlug.replace(/ /g, '+')
  const { videoSlug: _videoSlug, ...restQuery } = to.query
  const partnerIdParam = Array.isArray(to.params.partnerId)
    ? to.params.partnerId[0]
    : to.params.partnerId

  const params = { slug: normalizedSlug }
  if (partnerIdParam) {
    params.partnerId = partnerIdParam
  }

  return {
    name: targetName,
    params,
    query: restQuery,
  }
}

const unauthenticatedRoutes = [
  {
    path: '/:partnerId([^/]+)?/video',
    redirect: buildVideoSlugRedirect('video-detail'),
  },
  {
    path: '/:partnerId([^/]+)?/play',
    redirect: buildVideoSlugRedirect('video-player'),
  },
  {
    path: '/:partnerId([^/]+)?/video/:slug',
    name: 'video-detail',
    component: VideoDetailView,
  },
  {
    path: '/:partnerId([^/]+)?/play/:slug',
    name: 'video-player',
    component: VideoPlayerView,
  },
  {
    path: '/:partnerId([^/]+)?/series/:slug',
    name: 'series-detail',
    component: SeriesDetailView,
  },
  {
    path: '/:partnerId([^/]+)?',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('../views/NotFoundView.vue'),
  },
]

const routes = [
  ...protectedRoutes.map(route => ({
    ...route,
    beforeEnter: authGuard,
  })),
  ...unauthenticatedRoutes,
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
})

export default router
